import { Routes, Route} from 'react-router-dom';
import './App.css';
import '@fontsource/poppins'; 
import "@fontsource/manrope";
import "@fontsource/syne";
import "@fontsource/dm-sans";
import "@fontsource-variable/material-symbols-outlined";
import HomeTop from './Component/HomeTop';
import Shop from './Component/Shop';
import MapUI from './Component/MapUI';
import VoiceCommand from './Component/VoiceCommand';
import Contact from './Component/Contact';
import Downlaoder from './Component/Downlaoder';
import Forgot from './Logic/Forgot';
import Login from './Auth/Login';
import Console from './Auth/Console';
import Signup from './Auth/Signup';
import History from './Auth/History';
import VendorForgot from './Logic/VendorForgot';
import GetStarted from './Component/GetStarted';
import Privacy from './Component/Privacy';
import Terms from './Component/Terms';
import Unsbscribe from './Component/Unsubscribe';
import CookieConsent from 'react-cookie-consent';
import Me from './Component/Me';
import SchoolConsole from './SchoolPartner/SchoolConsole';
import Travelconsole from './TransportPartner/Travelconsole';
import UILiveLanding from './Component/Waitlist';
import TrackingConsentPolicy from './Component/Tracking-consent';




function App() {
  return (
    <>
      <Routes> 
          <Route path='/' element={<HomeTop/>} />
          <Route path='/forgotpass/:k' element={<Forgot/>} />
          <Route path='/shop/:m' element={<Shop/>} />
          <Route path='/voice/' element={<VoiceCommand/>} />
          <Route path='/contact/' element={<Contact/>} />
          <Route path='/download/:k' element={<Downlaoder/>} />
          <Route path='/signin' element={<Login/>} />
          <Route path='/signup' element={<Signup/>} />
          <Route path='/console' element={<Console/>} />
          <Route path='/histroy' element={<History/>} />
          <Route path='/forgot' element={<VendorForgot/>} />
          <Route path='/start' element={<GetStarted/>} />
          <Route path='/privacy-policy' element={<Privacy/>} />
          <Route path='/terms' element={<Terms/>} />
          <Route path='/unsubscribe/:e' element={<Unsbscribe/>} />
          <Route path='/me/:e' element={<Me/>} />
          <Route path='/schools/' element={<SchoolConsole/>} />
          <Route path='/trips' element={<Travelconsole/>} />
          <Route path='/waitlist' element={<UILiveLanding/>} />
          <Route path='/consent' element={<TrackingConsentPolicy/>} />
          {/* <Route path='/map/:k' element={<MapUI/>} /> */}
      </Routes>  
      
        <CookieConsent
              location="bottom"
              buttonText="Accept All"
              declineButtonText="Decline"
              enableDeclineButton
              cookieName="myWebsiteCookieConsent"
              style={{ background: "#060d1a", fontSize: "14px", overflowX:"hidden", overflowY:"hidden"}}
              buttonStyle={{ color: "#4e543c", backgroundColor: "#fff", fontSize: "13px", borderRadius: "4px" }}
              declineButtonStyle={{ color: "#fff", backgroundColor: "#c1272d", fontSize: "13px", borderRadius: "4px" }}
              expires={150}
              debug={false}
              onAccept={(acceptedByScrolling) => {
                  if (acceptedByScrolling) {
                    console.log("Accept was triggered by user scrolling");
                  } else {
                    console.log("User accepted cookies explicitly");
                    // Activate your tracking/analytics scripts here (e.g., Google Analytics)
                  }
                }}
                onDecline={() => {
                  console.log("User declined cookies");
                }}>
                 This website uses cookies to enhance the user experience 
                 You can read our full policy by visiting our{" "}
                <a 
                  href="/privacy-policy" 
                  style={{ color: "#15aabf", textDecoration: "underline" }}
                >
               &nbsp; Privacy Policy page
              </a>.
      </CookieConsent>
      
    </>
          
  );
}

export default App;
